document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll(".cart__item-sub .js-qty__adjust");
  const inputs = document.querySelectorAll(".cart__item-sub .js-qty__num");
  if(inputs) {
    inputs.forEach(input => {
      input.addEventListener("change", () => {
          setTimeout(()=> {
            BSS_B2B?.observer?.cartSubject?.notifyObserver('CartMutate', 'CartPriceMutate');
          }, 1000)
      })
    })
  }
  if(buttons) {
    buttons.forEach(button => {
      button.addEventListener("click", () => {
        setTimeout(()=> {
          BSS_B2B?.observer?.cartSubject?.notifyObserver('CartMutate', 'CartPriceMutate');
        }, 1000)
      })
    })
  }
  
(() => {
  setTimeout(() => {
    handleQuickView();
  }, 1000);
})();

function handleQuickView() {
  const targetNodes = document.querySelectorAll('.modal.modal--square.modal--quick-shop');

  if (targetNodes.length > 0) {
    targetNodes.forEach((node) => {
      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'class'
          ) {
            setTimeout(() => {
              document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
            }, 2000);
          }
        }
      });

      const config = {
        attributes: true,
        attributeFilter: ['class'],
      };

      observer.observe(node, config);
    });
  }
}

  const isCartPage = window.location.href.includes("cart");
  if(isCartPage) {
    if(BSS_B2B) {
      const checkoutBtn = document.querySelector('.cart__checkout');
      const checkbox = document.getElementById('CartTerms');
    
      if (checkoutBtn && checkbox) {
        checkoutBtn.addEventListener('click', function (e) {
          if (!checkbox.checked) {
            e.preventDefault();
            e.stopImmediatePropagation();
            alert('Pentru a continua, trebuie să fiți de acord cu termenii și condițiile de vânzare.');
            return false;
          }
        });
      }
    }
  }
});
